module.exports = __webpack_public_path__ + "aac3fc4a76c5bf3b49428fba31c05cdd.jpg";